import gql from 'graphql-tag'
import { PERSONAL_PROFILE } from './user'

export const APPRAISAL_TEMPLATE = gql`
  fragment AppraisalTemplate on AppraisalTemplate {
    id
    type
    name
    description
    appraisalFieldTemplates {
      name
      description
      children {
        name
        description
        children {
          name
          description
        }
      }
    }
  }
`

export const APPRAISAL_ASSIGN = gql`
  fragment AppraisalAssign on AppraisalAssign {
    id
    appraisalId
    appraisal {
      name
      standard
      type
    }
    personalProfile {
      id
      name
      designation
      organisationTitleId
      roles {
        role {
          name
          permissions
        }
      }
      media {
        id
        url
        fileName
      }
    }
    personalProfileId
    selfRating
    managerRating
    name
    peerRating
    startDate
    endDate
    status
    # personalProfile {
    #   id
    #   name
    #   designation
    #   roles {
    #     role {
    #       name
    #       permissions
    #     }
    #   }
    #   media {
    #     id
    #     url
    #     fileName
    #   }
    # }
    records {
      type
      status
      id
      rating
      personalProfileId
      personalProfile {
        name
      }
      submittedBy {
        ...PersonalProfile
      }
    }
  }
  ${PERSONAL_PROFILE}
`

export const APPRAISAL_RECORD = gql`
  fragment AppraisalRecord on AppraisalRecord {
    id
    submittedBy {
      ...PersonalProfile
    }
    personalProfileId
    personalProfile {
      ...PersonalProfile
    }
    rating
    status
    confirmationMetadata
    type
    updatedAt
    insertedAt
    appraisal {
      name
      description
      standard
      type
      appraisalFramework {
        name
        frequency
        appraisalSchedules {
          startDate
          endDate
        }
      }
    }
    appraisalAssign {
      ...AppraisalAssign
    }
    appraisalRecordDetails {
      appraisalFieldId
      description
      id
      insertedAt
      name
      note
      rating
      updatedAt
      children {
        appraisalFieldId
        description
        id
        insertedAt
        name
        note
        rating
        updatedAt
      }
    }
  }
  ${APPRAISAL_ASSIGN}
  ${PERSONAL_PROFILE}
`

export const APPRAISAL_ASSIGN_DETAILS = gql`
  fragment AppraisalAssignDetail on AppraisalAssignDetail {
    managerRating
    selfRating
    peerRating
    appraisalField {
      name
      description
    }
    children {
      managerRating
      selfRating
      peerRating
      appraisalField {
        name
        description
      }
    }
  }
`

export const APPRAISAL_ASSIGN_WITH_ASSIGN_DETAILS = gql`
  fragment AppraisalAssignWithAssignDetails on AppraisalAssign {
    id
    appraisalId
    appraisal {
      name
      standard
      type
    }
    appraisalAssignDetails {
      ...AppraisalAssignDetail
    }
    personalProfileId
    selfRating
    managerRating
    name
    peerRating
    startDate
    endDate
    status
    personalProfile {
      id
      name
      roles {
        role {
          name
          permissions
        }
      }
      media {
        id
        url
        fileName
      }
    }
    records {
      ...AppraisalRecord
    }
  }
  ${APPRAISAL_ASSIGN_DETAILS}
  ${APPRAISAL_RECORD}
`

export const APPRAISAL_FIELD = gql`
  fragment AppraisalField on AppraisalField {
    order
    name
    description
  }
`

export const V2_PERFORMANCE_CONVERSATION = gql`
  fragment PerformanceConversation on V2PerformanceConversation {
    id
    author {
      id
      name
      media {
        url
      }
    }
    comment: message
    updatedAt
    performanceChecklistItemId
  }
`

export const V2_PERFORMANCE_EXPECTATION = gql`
  fragment PerformanceExpectation on V2PerformanceChecklistExpectation {
    id
    isFailedExpectation
  }
`

export const V2_PERFORMANCE_COMMENT = gql`
  fragment PerformanceComment on V2PerformanceComment {
    id
    author {
      id
      name
      media {
        url
      }
    }
    type
    comment
    updatedAt
  }
`

export const V2_CHECKLIST_EVALUATION_DETAIL = gql`
  fragment V2PerformanceChecklistEvaluationDetail on V2PerformanceChecklistEvaluationDetail {
    id
    status
    updatedAt
    roleGroup
    notes {
      title
      description
    }
    appraisee {
      name
      dateJoin
      designation
      organisationTitleId
      school {
        name
      }
    }
    normalizedValue
    generalSettings
    value
    performanceConversations {
      author {
        id
        name
        media {
          url
        }
      }
      id
      comment: message
      updatedAt
      performanceChecklistItemId
    }
    signOffComments: performanceChecklistEvaluationComments(types: [SIGN_OFF_COMMENT]) {
      ...PerformanceComment
    }
    moderationComments: performanceChecklistEvaluationComments(types: [MODERATION_COMMENT]) {
      ...PerformanceComment
    }
    goalSettingsComments: performanceChecklistEvaluationComments(types: [ACCEPT_COMMENT, REJECT_COMMENT]) {
      ...PerformanceComment
    }
    checklistRecords {
      id
      roleId
      checklistId
      value
      normalizedValue
      personalProfileId
    }
    role
    participants {
      roleId
      name
      type
      designation
      organisationTitleId
    }
    period {
      name
      startDate
      endDate
    }
    buttons {
      actionParams
      actionType
      buttonText
      buttonType
    }
    performanceChecklistExpectations {
      id
      isFailedExpectation
      performanceChecklistItemId
    }
    permissionSettings
    checklistItems {
      id
      parentId
      name
      order
      hint
      description
      calculationSettings
      inputSettings
      checklistItemRecords {
        performanceChecklistItemId
        id
        value
        normalizedValue
        roleId
        performanceComments: performanceChecklistItemRecordComments(types: [EVIDENCE_COMMENT]) {
          id
          author {
            id
            name
            media {
              url
            }
          }
          comment
          updatedAt
        }
      }
    }
  }
  ${V2_PERFORMANCE_COMMENT}
`
